module.exports = __webpack_public_path__ + "img/parsertick.119ebc29.svg";